export const arrayToMap = (array: any[], keyField: string) => {
  let out: { [x: string]: any } = {};
  array.forEach((item) => {
    out[item[keyField]] = out[item[keyField]]?.length
      ? [...out[item[keyField]], item]
      : [item];
  });
  return out;
};
